export const transactions_table_display = {
  empty: "No transactions found",
  outstanding_badge: "Outstanding",
  empty_cell: "—",
  allocated_of_total: "{allocated} / {total}",
  col_posted_at: "Posted",
  col_counterparty: "Counterparty",
  col_amount: "Amount",
  col_status: "Status",
  col_allocated: "Allocated",
  col_outstanding: "Outstanding",
};
